module.exports = __webpack_public_path__ + "img/qrCode.0ce6df5b.png";